<template>
    <v-container>
        <!-- <v-row>
            <pre>{{ items }}</pre>
        </v-row> -->
        <v-row
            v-if="posts && posts.length > 0"
            column
            justify-center
            align-center
            :class="{ 'featured-wrapper': true, featuredPosts: true }"
        >
            <v-col
                v-for="(card, i) in featuredPosts"
                :key="
                    `${
                        card.slug &&
                        card.slug[$i18n.locale] &&
                        card.slug[$i18n.locale].current
                            ? card.slug[$i18n.locale].current
                            : i
                    }`
                "
                cols="12"
                xs="12"
                sm="4"
                md="4"
                lg="4"
                xl="4"
                :class="{
                    featured: true,
                    'col--xs': $vuetify.breakpoint.xsOnly,
                    'col--sm': $vuetify.breakpoint.smOnly,
                    'col--md': $vuetify.breakpoint.mdOnly,
                    'col--lg': $vuetify.breakpoint.lgOnly,
                    'col--xl': $vuetify.breakpoint.xlOnly,
                    'col--sm-and-down': $vuetify.breakpoint.smAndDown
                }"
            >
                <CardSinglePost :post="card" :img-crop="setCrop()" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import postUtilities from '~/mixins/postUtilities'
import CardSinglePost from '~/components/cards/CardSinglePost.vue'
export default {
    name: 'FeaturedPosts',
    components: {
        CardSinglePost
    },
    mixins: [postUtilities],
    props: {
        // items: {
        //     type: Array,
        //     default: null
        // },
        // page: {
        //     type: Object,
        //     default: null
        // },
        // content: {
        //     type: Object,
        //     default: null
        // }
    },
    methods: {
        // shouldSqueeze(str) {
        //     return str.length < 20 || false
        // },
        fallbackImageId(thumb) {
            return thumb && thumb.imageId ? thumb.imageId : 'c3controls-icon'
        },
        fallbackImageDir(thumb) {
            return thumb && thumb.imageDir ? thumb.imageDir : 'logos'
        },
        fallbackImageAlt(thumb) {
            return thumb && thumb.alt
                ? thumb.alt
                : { en: 'c3controls', es: 'c3controls' }
        }
    }
}
</script>
